export default "__VITE_ASSET__G5tZt80c__"